import request from '@/services/interceptor.js'

export const get_contenutiSicurezza = (filtri) => {
    return request({ url: '/contenutosicurezza', method: 'get', params: filtri || {}, loadingBar: true })
}

export const get_contenutoSicurezza = (id) => {
    return request({ url: `/contenutosicurezza/${id}`, method: 'get', loadingBar: true })
}

// Catena delle sostituzioni (dall'articolo indicato, tipicamente quello attivo,
// fino a quello originale): vedi nota in ContenutoSicurezzaController.GetStorico.
export const get_storico_contenutoSicurezza = (id) => {
    return request({ url: `/contenutosicurezza/${id}/storico`, method: 'get', loadingBar: true })
}

export const create_contenutoSicurezza = (par) => {
    return request({ url: '/contenutosicurezza', method: 'post', data: par, loadingBar: true })
}

export const update_contenutoSicurezza = (id, par) => {
    return request({ url: `/contenutosicurezza/${id}`, method: 'put', data: par, loadingBar: true })
}

// Chiude l'articolo scaduto (resta nello storico) e ne crea uno nuovo con le
// date fornite dall'utente: vedi nota in ContenutoSicurezzaController.Sostituisci.
export const sostituisci_contenutoSicurezza = (id, par) => {
    return request({ url: `/contenutosicurezza/${id}/sostituisci`, method: 'post', data: par, loadingBar: true })
}

export const duplica_contenutoSicurezza = (id) => {
    return request({ url: `/contenutosicurezza/${id}/duplica`, method: 'post', loadingBar: true })
}

export const elimina_contenutoSicurezza = (id) => {
    return request({ url: `/contenutosicurezza/${id}`, method: 'delete', loadingBar: true })
}
